import type { User } from '~/types/user';

export const usePermissions = () => {
  const auth = useAuth();
  const clientStore = useClientsStore();

  const hasPermission = (...permissions: string[]): boolean => {
    const user = auth.user as unknown as User | null;
    const allPermissions = [
      ...(user?.permissions || []),
      ...clientStore.clientPermissions,
    ];
    return permissions.every(permission => allPermissions.includes(permission));
  };

  const hasAnyPermission = (...permissions: string[]): boolean => {
    const user = auth.user as unknown as User | null;
    const allPermissions = [
      ...(user?.permissions || []),
      ...clientStore.clientPermissions,
    ];
    return permissions.some(permission => allPermissions.includes(permission));
  };

  return {
    hasPermission,
    hasAnyPermission,
  };
};
